export default "__VITE_ASSET__k31SAwZX__"